import { useTranslation } from 'react-i18next';

const values = [
  { iconKey: 'ri-medal-line', colorClass: 'bg-amber-50 text-amber-600', titleKey: 'about_val1_title', descKey: 'about_val1_desc' },
  { iconKey: 'ri-shield-check-line', colorClass: 'bg-sky-50 text-sky-600', titleKey: 'about_val2_title', descKey: 'about_val2_desc' },
  { iconKey: 'ri-heart-line', colorClass: 'bg-rose-50 text-rose-600', titleKey: 'about_val3_title', descKey: 'about_val3_desc' },
  { iconKey: 'ri-lightbulb-line', colorClass: 'bg-purple-50 text-purple-600', titleKey: 'about_val4_title', descKey: 'about_val4_desc' },
  { iconKey: 'ri-community-line', colorClass: 'bg-emerald-50 text-emerald-600', titleKey: 'about_val5_title', descKey: 'about_val5_desc' },
  { iconKey: 'ri-hand-heart-line', colorClass: 'bg-orange-50 text-orange-600', titleKey: 'about_val6_title', descKey: 'about_val6_desc' },
];

export default function AboutValues() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-[#F8FAFB]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-sky-50 text-sky-700 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-widest mb-4">
            {t('about_values_tag')}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">{t('about_values_title')}</h2>
          <p className="text-slate-500 text-base max-w-2xl mx-auto">{t('about_values_desc')}</p>
        </div>

        {/* Values grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {values.map((val, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-7 border border-slate-100 hover:border-sky-200 hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${val.colorClass} mb-5`}>
                <i className={`${val.iconKey} text-2xl`}></i>
              </div>
              <h3 className="text-slate-900 font-bold text-lg mb-2">{t(val.titleKey)}</h3>
              <p className="text-slate-500 text-sm leading-relaxed">{t(val.descKey)}</p>
            </div>
          ))}
        </div>

        {/* Bottom banner */}
        <div className="mt-16 bg-gradient-to-r from-[#0F2A50] to-sky-800 rounded-2xl px-8 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-5">
            <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-sky-500/20 shrink-0">
              <i className="ri-award-line text-sky-400 text-3xl"></i>
            </div>
            <div>
              <div className="text-white font-bold text-lg">Licensed, Certified &amp; Insured</div>
              <div className="text-white/60 text-sm mt-0.5">Georgia State License · WQA Certified · Energy Star Partner · BBB A+ Rated</div>
            </div>
          </div>
          <div className="flex items-center gap-4 shrink-0 flex-wrap justify-center md:justify-end">
            {['ri-verified-badge-line', 'ri-leaf-line', 'ri-star-line', 'ri-building-line'].map((icon, i) => (
              <div key={i} className="w-11 h-11 flex items-center justify-center rounded-full bg-white/10 hover:bg-sky-500/30 transition-colors">
                <i className={`${icon} text-white text-lg`}></i>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
